export default __webpack_public_path__ + "static/media/S2xCLUE3.abc5d71f.jpg";